/**
 * Gössl Theme - add-ons under the PDP pickers (r190, SJ 05.10.2026; Felix 22.09: an apron picker on the
 * Dirndl page). snippets/product-addons.liquid renders the rows it can decide on the server; this file
 *  - fills the list up from the best-selling feed (sections/product-addons-feed.liquid) when the block asks for it,
 *  - checks a row as soon as its size is chosen and shows that size's price,
 *  - hides the section's older note (data-addons-fallback) once the list shows a row (r190b),
 *  - preselects each row's size until the customer picks a size by hand: her own remembered apron size first (one
 *    she picked on an apron herself - r160: her own pick wins, a size derived from a Dirndl size does not count),
 *    then the main piece's size through the block's size map when the section sets one ("38:M 40:M"), otherwise
 *    through the Kundendienst apron rule the size memory follows (r160, 14.09: XS = 32-34, S = 36-38, M = 40-42,
 *    L = 44-46, from 48 nothing - GoesslPersonal.apronSize in assets/g26-personal.js); a size the apron does not
 *    offer or cannot sell falls through to the next, the last fallback is the placeholder,
 *  - hands product-form.js the checked lines: GoesslAddons.validate(block), .items(block), .reset(block).
 * The pre-order rule is the PDP's: a size without stock carries the Vorbestellung plan (data-plan, rendered from
 * snippets/preorder-plan + preorder-stock); window.g26preorder.capCart() runs after the add.
 * r195 shop the look (SJ 09.10.2026): rows marked data-addon-source="worn" are the pieces worn in this product's
 * photos (goessl.worn_with). A worn apron follows the apron sizes above; any other worn piece takes the main piece's
 * size when both share a size family (Dirndl 38 -> Bluse 38, Janker 50 -> Gilet 50 - GoesslPersonal.sizes.familyFor),
 * otherwise the size the visitor last picked in its own family, and a piece made in one size only takes that one.
 * The apron group (data-addons-rule) hides when the fill-up brings no apron, and only an apron row hides the section's
 * older "sold without apron" note. The "Bild ansehen" link (data-addons-photo) slides the gallery to the photo of
 * the first worn piece while that photo is in the gallery of the selected colour.
 */
(function () {
  'use strict';

  function rows(block) { return Array.prototype.slice.call(block.querySelectorAll('[data-addon]')); }

  function money(cents) {
    if (window.Goessl && window.Goessl.formatMoney) return window.Goessl.formatMoney(Number(cents) || 0);
    var parts = (Math.round(Number(cents) || 0) / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + ' €';
  }

  // "34:S 36:S 38:M" (also with commas or semicolons) -> { "34": "S", "36": "S", "38": "M" }
  function parseMap(text) {
    var map = {};
    String(text || '').split(/[\s,;]+/).forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2 && kv[0] && kv[1]) map[kv[0].trim().toUpperCase()] = kv[1].trim().toUpperCase();
    });
    return map;
  }

  // the main piece's size: the selected variant of the product form in the same section
  function mainSize(block, variant) {
    var idx = parseInt(block.getAttribute('data-size-index'), 10);
    if (isNaN(idx) || idx < 0) return null;
    if (!variant) {
      var section = block.closest('[data-section-id], .shopify-section') || document;
      var input = section.querySelector('[data-variant-id]');
      var json = section.querySelector('[data-product-json]');
      if (!input || !json) return null;
      try {
        var product = JSON.parse(json.textContent);
        variant = (product.variants || []).filter(function (v) { return String(v.id) === String(input.value); })[0];
      } catch (e) { return null; }
    }
    var value = variant && variant.options ? variant.options[idx] : null;
    return value ? String(value).split(' (')[0].trim().toUpperCase() : null;
  }

  function selectedOption(row) {
    var select = row.querySelector('[data-addon-size]');
    return select && select.value ? select.options[select.selectedIndex] : null;
  }

  // the visible box shows the chosen size (or the placeholder), the meta line its price and, for a size still to
  // come, "Vorbestellung"
  function paint(row) {
    var select = row.querySelector('[data-addon-size]');
    if (!select) return;
    var opt = selectedOption(row);
    var value = row.querySelector('[data-addon-size-value]');
    if (value) value.textContent = opt ? (opt.getAttribute('data-size') || opt.textContent) : select.options[0].textContent;
    if (select.parentNode) select.parentNode.classList.toggle('is-empty', !opt);
    var price = row.querySelector('[data-addon-price]');
    if (opt && price && opt.getAttribute('data-price')) price.textContent = money(opt.getAttribute('data-price'));
    var pre = row.querySelector('[data-addon-preorder]');
    if (pre) pre.hidden = !(opt && opt.getAttribute('data-plan'));
  }

  // r195: the size family of a row's product ('f:konf', 'f:schuerze', 'm:kragen' ...), from the attributes a worn row
  // carries; rule rows (aprons by tag) and pages without GoesslPersonal are aprons, as before
  function rowFamily(row) {
    if (row._family !== undefined) return row._family;
    var P = window.GoesslPersonal, fam = null;
    if (row.getAttribute('data-addon-source') === 'worn' && P && P.sizes && P.sizes.familyFor) {
      var select = row.querySelector('[data-addon-size]');
      var values = select ? Array.prototype.map.call(select.options, function (o) { return o.getAttribute('data-size'); }).filter(Boolean) : [];
      try {
        fam = P.sizes.familyFor({ tags: (row.getAttribute('data-addon-tags') || '').split('|'), type: row.getAttribute('data-addon-type') || '',
          title: row.getAttribute('data-addon-title') || '' }, values, null);
      } catch (e) { fam = null; }
    }
    row._family = fam;
    return fam;
  }
  function isApronRow(row) {
    if (row.getAttribute('data-addon-source') !== 'worn') return true;
    var fam = rowFamily(row);
    return fam ? /:schuerze$/.test(fam) : /sch(ü|ue)rze/i.test(row.getAttribute('data-addon-tags') || '');
  }

  // the main piece's size family, from the product JSON of the section
  function mainFamily(block) {
    var P = window.GoesslPersonal;
    if (!P || !P.sizes || !P.sizes.familyFor) return null;
    var section = block.closest('[data-section-id], .shopify-section') || document;
    var json = section.querySelector('[data-product-json]');
    if (!json) return null;
    try {
      var product = JSON.parse(json.textContent);
      var si = (product.options || []).indexOf('Größe');
      return P.sizes.familyFor(product, si < 0 ? [] : (product.variants || []).map(function (v) { return v.options[si]; }), null,
        (product.variants || []).map(function (v) { return v.sku; }));
    } catch (e) { return null; }
  }

  // r195: worn pieces that are not aprons - same family as the main piece: its size; another family: the visitor's
  // remembered size there; a piece made in one size only (bag, scarf): that size. The placeholder otherwise, never a
  // guess - not even when a single size of a sized piece is left.
  function applyWornSizes(block, variant) {
    var worn = rows(block).filter(function (row) { return !isApronRow(row) && !row.hasAttribute('data-size-touched'); });
    if (!worn.length) return;
    var P = window.GoesslPersonal;
    var size = mainSize(block, variant);
    var mainFam = mainFamily(block);
    worn.forEach(function (row) {
      var select = row.querySelector('[data-addon-size]');
      if (!select) return;
      var open = Array.prototype.filter.call(select.options, function (o) { return o.value && !o.disabled; });
      var bySize = function (s) {
        return s ? open.filter(function (o) { return String(o.getAttribute('data-size') || '').toUpperCase() === String(s).toUpperCase(); })[0] : null;
      };
      var fam = rowFamily(row), hit = null;
      if (fam && mainFam && fam === mainFam) hit = bySize(size);
      else if (fam && P && P.sizes && P.sizes.match) hit = bySize(P.sizes.match(fam, open.map(function (o) { return o.getAttribute('data-size'); })));
      var sized = Array.prototype.filter.call(select.options, function (o) { return o.value; });
      if (!hit && open.length === 1 && sized.length === 1) hit = open[0];
      select.value = hit ? hit.value : '';
      paint(row);
    });
  }

  // her own remembered apron size, or null: GoesslPersonal.sizes.get marks a size derived from the Dirndl size with
  // .derived (r190c; aprons are the only add-on today - another add-on family would need its own key here)
  function ownSize() {
    var P = window.GoesslPersonal;
    var e = P && P.sizes && P.sizes.get ? P.sizes.get('f:schuerze') : null;
    return e && e.alpha && !e.derived ? String(e.alpha).toUpperCase() : null;
  }

  function applySizeMap(block, variant) {
    applyWornSizes(block, variant);
    var map = parseMap(block.getAttribute('data-size-map'));
    var rule = window.GoesslPersonal && window.GoesslPersonal.apronSize;
    var custom = Object.keys(map).length > 0;
    var mine = ownSize();
    if (!custom && !rule && !mine) return;
    var size = mainSize(block, variant);
    var want = !size ? null : (custom ? map[size] : (rule ? rule(size) : null));
    rows(block).filter(isApronRow).forEach(function (row) {
      if (row.hasAttribute('data-size-touched')) return;
      var select = row.querySelector('[data-addon-size]');
      if (!select) return;
      var find = function (s) {
        return s ? Array.prototype.filter.call(select.options, function (o) {
          return !o.disabled && String(o.getAttribute('data-size') || '').toUpperCase() === s;
        })[0] : null;
      };
      var hit = find(mine) || find(want);
      select.value = hit ? hit.value : '';
      paint(row);
    });
  }

  function setError(block, on) {
    var err = block.querySelector('[data-addons-error]');
    if (err) err.hidden = !on;
    if (!on) rows(block).forEach(function (row) {
      var select = row.querySelector('[data-addon-size]');
      if (select) select.removeAttribute('aria-invalid');
    });
  }

  function bind(block) {
    block.addEventListener('change', function (e) {
      var row = e.target.closest('[data-addon]');
      if (!row) return;
      if (e.target.matches('[data-addon-size]')) {
        row.setAttribute('data-size-touched', '');
        var check = row.querySelector('[data-addon-check]');
        if (check && e.target.value) check.checked = true;
        if (e.target.value) e.target.removeAttribute('aria-invalid');
        paint(row);
      }
      if (e.target.matches('[data-addon-check]') && !e.target.checked) {
        var sel = row.querySelector('[data-addon-size]');
        if (sel) sel.removeAttribute('aria-invalid');
      }
      if (!block.querySelector('[data-addon-size][aria-invalid="true"]')) setError(block, false);
    });
  }

  function finish(block) {
    block.classList.remove('is-loading');
    block.hidden = rows(block).length === 0;
    // r195: the apron rows only - the worn pieces come before them in their own list
    var list = block.querySelector('[data-addons-list]');
    var ruleRows = list ? list.querySelectorAll('[data-addon]').length : 0;
    var group = block.querySelector('[data-addons-rule]');
    if (group) group.hidden = ruleRows === 0;
    // r190b: a list with apron rows says "sold without apron" itself - the section's older note (data-addons-fallback) goes
    if (!block.hidden && ruleRows > 0) {
      var scope = block.closest('.shopify-section') || document;
      Array.prototype.forEach.call(scope.querySelectorAll('[data-addons-fallback]'), function (el) { el.hidden = true; });
    }
    rows(block).forEach(paint);
    applySizeMap(block);
    initPhoto(block);
  }

  // r195: the gallery slide of the first worn piece's photo, while the selected colour's gallery holds it
  function photoSlide(block) {
    var btn = block.querySelector('[data-addons-photo]');
    if (!btn) return null;
    var scope = block.closest('.shopify-section') || document;
    return scope.querySelector('[data-product-main-swiper] .swiper-wrapper > .swiper-slide[data-slide-index="' + btn.getAttribute('data-addons-photo') + '"]');
  }
  function syncPhoto(block) {
    var btn = block.querySelector('[data-addons-photo]');
    if (btn) btn.hidden = !photoSlide(block);
  }
  function initPhoto(block) {
    var btn = block.querySelector('[data-addons-photo]');
    if (!btn) return;
    if (!btn.hasAttribute('data-photo-ready')) {
      btn.setAttribute('data-photo-ready', '');
      btn.addEventListener('click', function () {
        var slide = photoSlide(block);
        if (!slide) { btn.hidden = true; return; }
        var band = slide.closest('[data-product-main-swiper]');
        var pos = Array.prototype.indexOf.call(slide.parentNode.children, slide);
        if (band && band.swiper && pos > -1) band.swiper.slideTo(pos, 300);
        var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        if (band && band.scrollIntoView) band.scrollIntoView({ block: 'center', behavior: smooth ? 'smooth' : 'auto' });
      });
    }
    syncPhoto(block);
  }

  // the best-selling fill-up: rows in the feed's order, never a piece twice, never more than the block's max
  function fill(block) {
    var max = parseInt(block.getAttribute('data-addons-max'), 10) || 3;
    var feed = block.getAttribute('data-addons-feed');
    var list = block.querySelector('[data-addons-list]');
    if (!feed || !list || rows(block).length >= max || !window.fetch) { finish(block); return; }
    fetch(feed, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var seen = {};
        seen[block.getAttribute('data-addons-self')] = true;
        rows(block).forEach(function (r) { seen[r.getAttribute('data-addon-handle')] = true; });
        Array.prototype.forEach.call(doc.querySelectorAll('[data-addons-feed-rows] [data-addon]'), function (row) {
          var handle = row.getAttribute('data-addon-handle');
          if (rows(block).length >= max || seen[handle]) return;
          seen[handle] = true;
          list.appendChild(document.importNode(row, true));
        });
      })
      .catch(function () { /* no fill-up: the hand-picked or nightly rows stay, an empty block hides */ })
      .then(function () { finish(block); });
  }

  // product-form.js: false (and the message, the first empty size focused) when a checked row has no size
  function validate(block) {
    var missing = rows(block).filter(function (row) {
      var check = row.querySelector('[data-addon-check]');
      return check && check.checked && !selectedOption(row);
    });
    missing.forEach(function (row) { row.querySelector('[data-addon-size]').setAttribute('aria-invalid', 'true'); });
    setError(block, missing.length > 0);
    if (missing.length) {
      var first = missing[0].querySelector('[data-addon-size]');
      first.focus();
      if (first.scrollIntoView) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return false;
    }
    return true;
  }

  // the checked rows as /cart/add.js items - quantity 1, the plan when the size has no stock, the article number
  function items(block) {
    return rows(block).map(function (row) {
      var check = row.querySelector('[data-addon-check]');
      var opt = selectedOption(row);
      if (!check || !check.checked || !opt) return null;
      var item = { id: Number(opt.value), quantity: 1 };
      var plan = opt.getAttribute('data-plan');
      if (plan) item.selling_plan = Number(plan);
      var artno = row.getAttribute('data-addon-artno');
      if (artno) item.properties = { '_Artikel-Nr': artno };
      return item;
    }).filter(Boolean);
  }

  // after a successful add: nothing stays checked, so a second click on the button never adds the aprons twice
  function reset(block) {
    rows(block).forEach(function (row) {
      var check = row.querySelector('[data-addon-check]');
      if (check) check.checked = false;
    });
    setError(block, false);
  }

  window.GoesslAddons = { validate: validate, items: items, reset: reset };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-addons]'), function (block) {
      if (block.hasAttribute('data-addons-ready')) return;
      block.setAttribute('data-addons-ready', '');
      bind(block);
      fill(block);
    });
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    // r195: the gallery is filtered to the new colour before this event fires
    Array.prototype.forEach.call(document.querySelectorAll('[data-addons]'), syncPhoto);
    if (!variant) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-addons]'), function (block) { applySizeMap(block, variant); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
